// CreateMessage Component for adding a new message

// Import Modules
import React, { useState, useEffect } from "react";
import axios from 'axios';
import MessageForm from "./MessageForm";

// CreateMessage Component
const CreateMessage = () => {
    const [formValues, setFormValues] =
        useState({ post: ''})
    // onSubmit handler
    const onSubmit = messageObject => {
        axios.post(
            'https://peaceo.hopto.org/messages/create-message',
            messageObject)
                .then(res => {
                    if(res.status === 200){
                        alert('successfully created message.');
                        
                        setTimeout(() => window.location.reload());
                    }
                    else
                        Promise.reject();
                })
                .catch( err => alert('Something went wrong.'));
    }

    // Return message form
    return(
        <MessageForm initialValues={formValues}
            onSubmit={onSubmit}
            enableReinitialize>
            Create Message
        </MessageForm>
    )
}

// Export CreateMessage Component
export default CreateMessage